import React, { lazy, Suspense, useCallback } from 'react'
import { useOverlay, useContainerWidth, IconButton } from '@fs/zion-ui'
import { css } from '@linaria/core'
import { useTranslation } from 'react-i18next'
import { HelpAi } from '@fs/zion-icon'
import ChatbotLaunchPillButton from './ChatbotLaunchPillButton'
import useChatbotSessionPreCheck from './hooks/useChatbotSessionPrecheck'

const HelpChatbot = lazy(() => import('./HelpChatbot'))

const stickyButtonCss = css`
  position: sticky;
  bottom: 0;
  inset-inline-end: 0;
  z-index: 2;

  button {
    position: absolute;
    bottom: calc(var(--spacer-sm) + var(--rootstech-promo-height, 0px));
    inset-inline-end: var(--spacer-sm);
  }
`

function ChatbotButton() {
  const { t } = useTranslation()
  const atWidth = useContainerWidth()
  const isMobile = atWidth({ default: true, md: false })
  const chatbotOverlay = useOverlay()
  const { handleClick: openOverlay } = chatbotOverlay
  const sessionPreCheck = useChatbotSessionPreCheck()
  const { recheckSession } = sessionPreCheck

  const handleClick = useCallback(
    async (e) => {
      // Get current timestamp when clicked
      await recheckSession()
      openOverlay(e)
    },
    [recheckSession, openOverlay]
  )

  return (
    <>
      <div className={stickyButtonCss}>
        {isMobile ? (
          <IconButton
            ref={chatbotOverlay.targetRef}
            title={t('help-overlay-button.text', 'Get Help')}
            color="gray"
            emphasis="high"
            Icon={HelpAi}
            onClick={handleClick}
            size="md"
            data-testid="help-overlay-lower-left"
            linkName="help-chatbot:open"
          />
        ) : (
          <ChatbotLaunchPillButton overlay={chatbotOverlay} onClickOverride={handleClick} />
        )}
      </div>

      <HelpChatbot overlay={chatbotOverlay} sessionPreCheck={sessionPreCheck} />
    </>
  )
}

export default function ChatbotLaunchButton() {
  return (
    <Suspense fallback={null}>
      <ChatbotButton />
    </Suspense>
  )
}
